module.exports = __webpack_public_path__ + "static/img/user2.d2c9e817.png";